import * as ambassadorWixAutomationsV1AutomationsCustomTrigger from './automations-v1-automations-custom-trigger-custom-trigger.http.js';
import * as ambassadorWixAutomationsV1AutomationsCustomTriggerTypes from './automations-v1-automations-custom-trigger-custom-trigger.types.js';
import * as ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes from './automations-v1-automations-custom-trigger-custom-trigger.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function runTrigger(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.RunTriggerRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.RunTriggerRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.RunTriggerResponse,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.RunTriggerResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV1AutomationsCustomTrigger.runTrigger(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/trigger-custom',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMainEntityTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.BulkUpdateMainEntityTagsRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.BulkUpdateMainEntityTagsRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.BulkUpdateMainEntityTagsResponse,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.BulkUpdateMainEntityTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV1AutomationsCustomTrigger.bulkUpdateMainEntityTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk-update-main-entity-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMainEntityTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.BulkUpdateMainEntityTagsByFilterRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.BulkUpdateMainEntityTagsByFilterRequest,
  ambassadorWixAutomationsV1AutomationsCustomTriggerUniversalTypes.BulkUpdateMainEntityTagsByFilterResponse,
  ambassadorWixAutomationsV1AutomationsCustomTriggerTypes.BulkUpdateMainEntityTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV1AutomationsCustomTrigger.bulkUpdateMainEntityTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk-update-main-entity-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MainEntity as MainEntityOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  RunTriggerRequest as RunTriggerRequestOriginal,
  RunTriggerResponse as RunTriggerResponseOriginal,
  BulkUpdateMainEntityTagsRequest as BulkUpdateMainEntityTagsRequestOriginal,
  BulkUpdateMainEntityTagsResponse as BulkUpdateMainEntityTagsResponseOriginal,
  BulkUpdateMainEntityTagsByFilterRequest as BulkUpdateMainEntityTagsByFilterRequestOriginal,
  BulkUpdateMainEntityTagsByFilterResponse as BulkUpdateMainEntityTagsByFilterResponseOriginal,
} from './automations-v1-automations-custom-trigger-custom-trigger.types.js';
